import StudentsModule from '@features/Students/Student.Module';
import React from 'react';

const Students = () => {
  return <StudentsModule />;
};

export default Students;
